// Local translations
export const T = {
  en_GB: {
    duplicateFlow: "Duplicate Flow",
    cloneFlowDescription:
      "Create a copy of this flow with all its pages, fields and components. The copy starts inactive.",
    flowName: "Flow Name",
    description: "Description",
    descriptionPlaceholder: "Optional description of what this flow is for",
    cancel: "Cancel",
    duplicate: "Duplicate",
    failedToCloneFlow: "Failed to duplicate flow",
    language: "Language",
    original: "original",
    translateTo: (language: string) => `Translate texts to ${language} with AI`,
    translateHint:
      "Page names, fields, options and component texts are translated together, so terms stay consistent. Placeholders are kept. The translation runs in the background, and the list shows its progress.",
    noTranslateHint: "The copy is set to the new language, but its texts stay as they are.",
    includePdfTemplate: (name: string) => `Also duplicate the PDF template "${name}"`,
    includePdfTemplateHint:
      "The copy is linked to the new flow, with its fields, quizzes and pages pointing at the copies.",
    pdfTemplateName: "PDF template name",
    copyQueued: "Translating the copy. It shows up in the list when it is ready.",
  },
  nb_NO: {
    duplicateFlow: "Dupliser flyt",
    cloneFlowDescription:
      "Opprett en kopi av denne flyten med alle sider, felt og komponenter. Kopien starter som inaktiv.",
    flowName: "Flytnavn",
    description: "Beskrivelse",
    descriptionPlaceholder: "Valgfri beskrivelse av hva denne flyten er for",
    cancel: "Avbryt",
    duplicate: "Dupliser",
    failedToCloneFlow: "Kunne ikke duplisere flyt",
    language: "Språk",
    original: "original",
    translateTo: (language: string) => `Oversett tekstene til ${language} med AI`,
    translateHint:
      "Sidenavn, felt, alternativer og komponenttekster oversettes samlet, så begrepene blir like. Plassholdere beholdes. Oversettelsen kjører i bakgrunnen, og listen viser fremdriften.",
    noTranslateHint: "Kopien får det nye språket, men tekstene beholdes som de er.",
    includePdfTemplate: (name: string) => `Dupliser også PDF-malen «${name}»`,
    includePdfTemplateHint:
      "Kopien kobles til den nye flyten, og felt, quizer og sider peker på kopiene.",
    pdfTemplateName: "Navn på PDF-mal",
    copyQueued: "Kopien oversettes. Den dukker opp i listen når den er klar.",
  },
} as const;
